module.exports = __webpack_public_path__ + "img/Facebook_icon.b605aecf.png";